"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

// used to convert numeric value to px value
// used by the image & wrapper
function convertDimensions(value) {
  if (/^\d+$/.test(value)) {
    return "".concat(value, "px");
  }

  return value;
} // used only by the image to convert the width/height value for the image


function handleImageDimension(value) {
  value = convertDimensions(value);

  if (/%$/.test(value)) {
    // make the image fill the wrapping element that contains the % width
    return "100%";
  }

  return value;
}

function placeholderDimension(value, calculatedValue) {
  var dim = value;

  if (!value || value === "" || /%$/.test(value)) {
    dim = calculatedValue && calculatedValue > 0 ? calculatedValue : "125";
  }

  return parseInt(dim.toString().replace(/\D+/g, ""));
}

var ImagePreview = function ImagePreview(_ref) {
  var classes = _ref.classes,
      _ref$content$attrs = _ref.content.attrs,
      src = _ref$content$attrs.src,
      height = _ref$content$attrs.height,
      alt = _ref$content$attrs.alt,
      width = _ref$content$attrs.width,
      title = _ref$content$attrs.title,
      url = _ref$content$attrs.url,
      calculatedWidth = _ref$content$attrs.calculatedWidth,
      isEditor = _ref.internals.isEditor,
      refCallback = _ref.refCallback,
      reCalculate = _ref.reCalculate;
  var isPlaceholder = !/^(?:http(s)?:\/\/)/.test(src);
  var imgSrc = src;

  if (isPlaceholder) {
    var w = placeholderDimension(width, calculatedWidth);
    var h = placeholderDimension(height, w);
    imgSrc = "https://via.placeholder.com/".concat(w, "x").concat(h);
  }

  var img = /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.imageWrapper
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.root,
    src: imgSrc,
    alt: alt,
    title: title,
    ref: refCallback,
    onLoad: reCalculate
  }));

  if (!url) {
    return img;
  }

  return /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    title: title,
    onClick: function onClick(e) {
      if (isEditor) {
        e.preventDefault();
      }
    }
  }, img);
};

var _default = (0, _withStyles["default"])(function (theme) {
  return {
    imageWrapper: {
      display: "inline-block",
      verticalAlign: "bottom",
      width: function width(_ref2) {
        var attrs = _ref2.content.attrs;
        return convertDimensions(attrs && attrs.width);
      },
      height: function height(_ref3) {
        var attrs = _ref3.content.attrs;
        return convertDimensions(attrs && attrs.height);
      }
    },
    root: {
      maxWidth: "100%",
      width: function width(_ref4) {
        var attrs = _ref4.content.attrs;
        return handleImageDimension(attrs && attrs.width);
      },
      height: function height(_ref5) {
        var attrs = _ref5.content.attrs;
        return handleImageDimension(attrs && attrs.height);
      },
      display: "inline-block",
      verticalAlign: "bottom"
    }
  };
})(ImagePreview);

exports["default"] = _default;